import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ospTemplate]',
  standalone: true
})
export class OspTemplateDirective {
  @Input('ospTemplate') name: string | undefined;
  @Input() type: string | undefined;
  constructor(public template: TemplateRef<unknown>) { }
}
